import { render, staticRenderFns } from "./Roles.vue?vue&type=template&id=c2828df2&scoped=true"
import script from "./Roles.vue?vue&type=script&lang=js"
export * from "./Roles.vue?vue&type=script&lang=js"
import style0 from "./Roles.vue?vue&type=style&index=0&id=c2828df2&prod&scoped=true&lang=css"
import style1 from "./Roles.vue?vue&type=style&index=1&id=c2828df2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2828df2",
  null
  
)

export default component.exports